import {History} from 'history';
import {useFeatureServices} from './use-feature-services';

export function useHistory(): History {
  const {'s2:history': historyService} = useFeatureServices();

  return historyService.history;
}
